module.exports = __webpack_public_path__ + "static/img/certificateWL.4a494349.jpg";